module.exports = __webpack_public_path__ + "img/activityBG2.464a6aaf.png";